import Grid from "../../../components/Grid";
import Snackbar from "../../../components/Snackbar";
import { ghostLink } from "../../../helpers/ghost-link";
import { connect, useDispatch } from "react-redux";
import Tabs from "../../../components/Layout/ProfileLayout/components/Tabs";
import { showModal } from "./../../../store/actions/modal";
import ModalContactSupport from "./components/ModalContactSupport";
import {
  changeUserPassword,
  getSubscriptionsManagerUrl,
  getUserSubscriptions,
} from "./../../../store/actions/user";
import { useContext, useEffect, useMemo } from "react";
import { AuthContext } from "../../../providers/Auth";
import { FormTitle, Title, Button, Section } from "./styles";
import ChangeEmail from "./components/ChangeEmail";
import ChangePassword from "./components/ChangePassword";
import ChangeUsername from "./components/ChangeUsername";
import ChangeAvatar from "./components/ChangeAvatar";
import ChangePhone from "./components/ChangePhone";
import ChangeWhiteLabel from "./components/ChangeWhiteLabel";
import Link from "../../../components/Link";
import { Layout, useLayout } from "../../../providers/LayoutProvider";

interface ComponentProps {
  setActiveTab?;
  userSubscriptions;
  userData;
  userPasswordStates;
  subscriptionsManagerUrl;
  userStates;
}

const Component = ({
  userSubscriptions,
  userData,
  userStates,
  userPasswordStates,
  subscriptionsManagerUrl,
  setActiveTab,
}: ComponentProps) => {
  const dispatch = useDispatch();
  const { layout, setLayout } = useLayout();
  const { user } = useContext(AuthContext);

  const { data: subscruptionsManagerData, states: subscruptionsManagerStates } =
    subscriptionsManagerUrl;

  const { access_url } = subscruptionsManagerData || {};

  const isExpert = useMemo((): boolean => {
    return !!userData?.expert;
  }, [userData, userStates]);

  const goToSubscriptionsManager = () => {
    if (!!access_url) {
      ghostLink(access_url);
    } else {
      dispatch(getSubscriptionsManagerUrl());
    }
  };

  const layoutData = useMemo(
    (): Layout => ({
      ...layout,
      skin: "plain",
      footer: {
        visible: false,
      },
      header: {
        visible: true,
        actions: [],
      },
      page: {
        title: "Configuración de cuenta",
        description: "Configurar cuenta",
      },
      dashboard: {
        tabs: {
          visible: false,
        },
      },
      body: {
        visible: true,
      },
    }),
    [layout]
  );

  useEffect(() => {
    !!access_url && goToSubscriptionsManager();
  }, [subscruptionsManagerData]);

  useEffect(() => {
    !!user && dispatch(getUserSubscriptions(
      {
        filters: {
          status_in: "active,non_renewing,paid,pending_invite,waiting_for_gateway,not_paid,retrying,renewal_retrying",
        }
      }
    ));
  }, [user]);

  useEffect(() => {
    setActiveTab("profile");
    setLayout(layoutData);
  }, []);

  useEffect(() => {
    if (subscruptionsManagerStates.error) {
      dispatch(showModal("modal-contact-support"));
    }
  }, [subscruptionsManagerStates]);

  return (
    <Grid.Container>
      <Grid.Row style={{gap: "30px"}}>
        <Grid.Col sm={4}>
          <Title>Información general</Title>

          <div style={{ height: 27 }} />

          {isExpert && (
            <>
              <ChangeAvatar />
              <div style={{ height: 32 }} />
            </>
          )}

          {isExpert && (
            <>
              <ChangeUsername />
              <div style={{ height: 32 }} />
            </>
          )}

          <ChangeEmail />
          <div style={{ height: 32 }} />

          <ChangePassword />
          <div style={{ height: 32 }} />

          <ChangePhone />
        </Grid.Col>
  

        {isExpert && (
          <Grid.Col offset={{ sm: 1 }} sm={5}>
            <Title>Identidad visual</Title>

            <div style={{ height: 27 }} />

            <ChangeWhiteLabel />
          </Grid.Col>
        )}

        {/* <Grid.Col sm={4}>
          <Title>Administrar suscripciones</Title>
          {userSubscriptions?.length > 0 ? (
            <Button
              type="button"
              onClick={() => goToSubscriptionsManager()}
              loading={subscruptionsManagerStates.loading}
              options={{
                skin: "purple",
                size: "lg",
                type: "link",
              }}
            >
              Modificar
            </Button>
          ) : (
            "Aun no cuentas con suscripciones."
          )}
        </Grid.Col> */}


      </Grid.Row>

      <ModalContactSupport />
    </Grid.Container>
  );
};

const state = ({ userStore }) => {
  const {
    subscriptions,
    information,
    changeUserEmail,
    changeUserPassword,
    subscriptionsManagerUrl,
  } = userStore;

  const { data: userData, states: userStates } = information;
  const { data: userSubscriptions } = subscriptions;

  return {
    userSubscriptions,
    userData,
    userStates,
    userEmailStates: changeUserEmail.states,
    userPasswordStates: changeUserPassword.states,
    subscriptionsManagerUrl,
  };
};

export default connect(state)(Component);
